(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function lead(source) {
      try { document.dispatchEvent(new CustomEvent('analytics:generate_lead', { detail: { source: source } })); } catch (e) {}
    }
    function fire(scope) {
      [['[data-b2b-success]', 'b2b_contact'], ['[data-retail-success]', 'retail_contact']].forEach(function (p) {
        var el = (scope || document).querySelector(p[0]);
        if (!el || el.dataset.tracked) return;
        el.dataset.tracked = '1';
        lead(p[1]);
      });
    }
    fire(document);
    if (window.__mkContactBound) return;
    window.__mkContactBound = true;
    document.addEventListener('shopify:section:load', function (e) { fire(e.target); });
    /* WhatsApp clicks are tracked (whatsapp_click) and opened by assets/maison.js via data-wa-*. */
    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-retail-link="instagram"]');
      if (link) lead('instagram_click');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    /* posted_successfully? is true for every customer form on the page (the batch waitlist too),
       so the submit leaves a marker; no storage = trust the server render */
    document.addEventListener('submit', function (e) {
      if (e.target && e.target.id === 'listForm') { try { sessionStorage.setItem('mk:posted', 'footer'); } catch (x) {} }
    });
    var ok = document.querySelector('.footer [data-newsletter-success]');
    if (!ok) return;
    var mine = true;
    try { mine = sessionStorage.getItem('mk:posted') === 'footer'; if (mine) sessionStorage.removeItem('mk:posted'); } catch (x) {}
    if (!mine) { ok.textContent = ''; ok.removeAttribute('data-newsletter-success'); return; }
    document.dispatchEvent(new CustomEvent('analytics:generate_lead', { detail: { source: 'footer' } }));
    /* once only: drop the flag so a reload doesn't re-render the success or re-fire the lead */
    try { var u = new URL(location.href); u.searchParams.delete('customer_posted'); history.replaceState(history.state, '', u); } catch (x) {}
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gifts-corporate"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function fire(scope) {
      var ok = (scope || document).querySelector('[data-corp-success]');
      if (!ok || ok.dataset.tracked) return;
      ok.dataset.tracked = '1';
      try { document.dispatchEvent(new CustomEvent('analytics:generate_lead', { detail: { source: 'gifts_corporate_form' } })); } catch (e) {}
    }
    fire(document);
    document.addEventListener('shopify:section:load', function (e) { fire(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /* <search-panel>: the header search. Opens under the header, traps focus, Escape or the scrim closes it.
     Empty input shows the suggestions (House Five); typing fetches predictive results as rendered HTML. */
  (function () {
    if (customElements.get('search-panel')) return;
    var SECTION = 'search-suggest';
    var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), [tabindex]:not([tabindex="-1"])';
    customElements.define('search-panel', class extends HTMLElement {
      connectedCallback() {
        this.sheet = this.querySelector('.hs-sheet');
        this.form = this.querySelector('form');
        this.input = this.querySelector('input[type="search"]');
        this.results = this.querySelector('[data-hs-results]');
        this.status = this.querySelector('[role="status"]');
        this.cache = {};
        this.current = null;
        this.onDocClick = this.docClick.bind(this);
        this.onKey = this.key.bind(this);
        this.onInput = this.typed.bind(this);
        this.onSubmit = this.submit.bind(this);
        this.onResize = this.place.bind(this);
        document.addEventListener('click', this.onDocClick);
        document.addEventListener('keydown', this.onKey);
        this.input.addEventListener('input', this.onInput);
        this.form.addEventListener('submit', this.onSubmit);
        window.addEventListener('resize', this.onResize);
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocClick);
        document.removeEventListener('keydown', this.onKey);
        this.input.removeEventListener('input', this.onInput);
        this.form.removeEventListener('submit', this.onSubmit);
        window.removeEventListener('resize', this.onResize);
        clearTimeout(this.typeTimer); clearTimeout(this.closeTimer); clearTimeout(this.trackTimer);
        if (this.ctrl) this.ctrl.abort();
        document.documentElement.classList.remove('hs-open');
      }

      get isOpen() { return !this.hidden && this.classList.contains('in'); }

      docClick(e) {
        var opener = e.target.closest('[data-search-open]');
        if (opener) { e.preventDefault(); if (this.isOpen) this.close(); else this.open(opener); return; }
        if (this.isOpen && e.target.closest('[data-hs-close]') && this.contains(e.target)) this.close();
      }

      key(e) {
        var opener = e.target.closest && e.target.closest('[data-search-open]');
        if (opener && e.key === ' ') { e.preventDefault(); this.open(opener); return; }
        if (!this.isOpen) return;
        if (e.key === 'Escape') { e.preventDefault(); this.close(); return; }
        if (e.key !== 'Tab') return;
        var f = Array.prototype.filter.call(this.sheet.querySelectorAll(FOCUSABLE), function (x) { return x.offsetParent !== null; });
        if (!f.length) return;
        var a = document.activeElement;
        if (!this.sheet.contains(a)) { e.preventDefault(); f[0].focus(); }
        else if (e.shiftKey && a === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && a === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }

      place() {
        var h = document.getElementById('header');
        var top = h ? Math.max(0, h.getBoundingClientRect().bottom) : 0;
        this.style.setProperty('--hs-top', top + 'px');
      }

      open(opener) {
        clearTimeout(this.closeTimer);
        this.opener = opener || this.opener;
        document.documentElement.classList.add('hs-open');
        this.place();
        this.hidden = false;
        document.querySelectorAll('[data-search-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
        var self = this;
        requestAnimationFrame(function () { self.classList.add('in'); self.place(); });
        this.input.focus({ preventScroll: true });
        this.load(this.input.value.trim());
      }

      close() {
        var self = this;
        this.classList.remove('in');
        document.documentElement.classList.remove('hs-open');
        document.querySelectorAll('[data-search-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
        this.closeTimer = setTimeout(function () { self.hidden = true; }, 250);
        if (this.opener && this.opener.focus) this.opener.focus({ preventScroll: true });
      }

      typed() {
        var self = this;
        clearTimeout(this.typeTimer);
        this.typeTimer = setTimeout(function () { self.load(self.input.value.trim()); }, 180);
      }

      submit(e) {
        if (!this.input.value.trim()) { e.preventDefault(); this.input.focus(); }
      }

      url(q) {
        if (!q) return this.dataset.rootUrl + '?section_id=' + SECTION;
        var p = new URLSearchParams();
        p.set('q', q);
        p.set('resources[type]', 'product,article');
        p.set('resources[limit]', '10');
        p.set('resources[limit_scope]', 'each');
        p.set('resources[options][unavailable_products]', 'last');
        p.set('resources[options][fields]', 'title,product_type,variants.title,tag,body');
        p.set('section_id', SECTION);
        return this.dataset.suggestUrl + '?' + p.toString();
      }

      load(q) {
        if (q === this.current) return;
        this.current = q;
        if (this.cache[q] != null) { this.render(this.cache[q], q); return; }
        if (this.ctrl) this.ctrl.abort();
        var ctrl = this.ctrl = ('AbortController' in window) ? new AbortController() : null;
        var self = this;
        this.results.setAttribute('aria-busy', 'true');
        fetch(this.url(q), { signal: ctrl ? ctrl.signal : undefined, headers: { Accept: 'text/html' } })
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
          .then(function (text) {
            var body = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-hs-body]');
            if (!body) throw new Error('empty');
            self.cache[q] = body.outerHTML;
            if (self.current === q) self.render(self.cache[q], q);
          })
          .catch(function (err) {
            if (err && err.name === 'AbortError') return;
            if (self.current === q) { self.current = null; self.results.setAttribute('aria-busy', 'false'); }
          });
      }

      render(html, q) {
        this.results.innerHTML = html;
        this.results.setAttribute('aria-busy', 'false');
        var body = this.results.querySelector('[data-hs-body]');
        if (this.status) this.status.textContent = body ? body.dataset.hsAnnounce || '' : '';
        clearTimeout(this.trackTimer);
        if (!q || q === this.tracked) return;
        var self = this, count = body ? Number(body.dataset.hsCount || 0) : 0;
        this.trackTimer = setTimeout(function () {
          self.tracked = q;
          document.dispatchEvent(new CustomEvent('analytics:search', { detail: { search_term: q, results_count: count, source: 'search_panel' } }));
        }, 1000);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-atelier"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('home-tin')) {
    customElements.define('home-tin', class extends HTMLElement {
      connectedCallback() {
        if (window.MKTin) this.setup();
        else {
          this.waitTin = () => this.setup();
          window.addEventListener('load', this.waitTin, { once: true });
        }
      }
      setup() {
        var T = window.MKTin;
        this.tin = this.querySelector('[data-mktin]');
        if (!T || !this.tin || this.done) return;
        this.done = true;
        try { this.labels = JSON.parse(this.querySelector('[data-tin-labels]').textContent) || []; } catch (e) { this.labels = []; }
        this.li = 0;
        this.typed = false;
        this.input = this.querySelector('[data-tin-try]');
        this.styles = this.querySelector('[data-tin-styles]');
        var tin = this.tin, self = this;
        var yourName = this.dataset.yourName || 'Your name', yourBlend = this.dataset.yourBlend || 'Your blend';
        T.paint(tin);
        if (this.styles) T.stylePicker(this.styles, tin.dataset.style, function (id) {
          self.typed = true;
          var L = self.labels[self.li] || {};
          T.paint(tin, { name: (self.input && self.input.value) || L.name || yourName, style: id, colour: T.DEFAULT[id], bump: true });
        });
        if (this.input) {
          this.onInput = function () {
            self.typed = true;
            T.paint(tin, { name: self.input.value || yourName, kind: yourBlend, style: tin.dataset.style, colour: tin.dataset.colour });
          };
          this.input.addEventListener('input', this.onInput);
        }
        if (this.labels.length < 2 || /static/.test(location.search)) return;
        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver(function (es) {
            if (es[es.length - 1].isIntersecting) self.start(); else self.stop();
          }, { threshold: 0.2 });
          this.io.observe(this);
        }
      }
      start() {
        if (this.timer) return;
        var T = window.MKTin, tin = this.tin, self = this;
        this.timer = setInterval(function () {
          if (self.typed) return self.stop();
          self.li = (self.li + 1) % self.labels.length;
          var L = self.labels[self.li];
          tin.classList.add('swap');
          clearTimeout(self.swapT);
          self.swapT = setTimeout(function () {
            T.paint(tin, { name: L.name, kind: L.kind, style: L.style, colour: L.colour });
            if (self.styles) T.select(self.styles, L.style);
            tin.classList.remove('swap');
          }, 420);
        }, 3800);
      }
      stop() {
        clearInterval(this.timer);
        this.timer = null;
      }
      disconnectedCallback() {
        this.stop();
        clearTimeout(this.swapT);
        if (this.io) this.io.disconnect();
        if (this.waitTin) window.removeEventListener('load', this.waitTin);
        if (this.input && this.onInput) this.input.removeEventListener('input', this.onInput);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-discover"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('home-tabs')) {
    customElements.define('home-tabs', class extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.prototype.slice.call(this.querySelectorAll('[role="tab"]'));
        this.onClick = (e) => {
          var b = e.target.closest('[role="tab"]');
          if (b && this.contains(b)) this.show(b, false);
        };
        this.onKey = (e) => {
          var i = this.tabs.indexOf(e.target);
          if (i < 0) return;
          var n = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1 : e.key === 'Home' ? 0 : e.key === 'End' ? this.tabs.length - 1 : null;
          if (n === null) return;
          e.preventDefault();
          this.show(this.tabs[(n + this.tabs.length) % this.tabs.length], true);
        };
        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKey);
      }
      show(b, focus) {
        this.tabs.forEach(function (x) {
          var on = x === b;
          x.classList.toggle('on', on);
          x.setAttribute('aria-selected', on);
          x.tabIndex = on ? 0 : -1;
          var p = document.getElementById(x.dataset.tab);
          if (p) p.classList.toggle('on', on);
        });
        var panel = document.getElementById(b.dataset.tab);
        if (panel) panel.querySelectorAll('.rv').forEach(function (el) { el.classList.add('in'); });
        if (focus) b.focus();
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKey);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-house-five"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('home-carousel')) {
    customElements.define('home-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.bar = this.querySelector('[data-progress]');
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        if (!this.track) return;
        this.step = () => {
          var c = this.track.firstElementChild;
          var gap = parseFloat(getComputedStyle(this.track).columnGap) || 24;
          return c ? c.getBoundingClientRect().width + gap : 300;
        };
        this.sync = () => {
          var t = this.track, max = t.scrollWidth - t.clientWidth, x = t.scrollLeft;
          var w = Math.max(20, t.clientWidth / Math.max(1, t.scrollWidth) * 100);
          if (this.bar) { this.bar.style.width = w + '%'; this.bar.style.left = (max > 0 ? x / max * (100 - w) : 0) + '%'; }
          if (this.prev) this.prev.disabled = x < 4;
          if (this.next) this.next.disabled = x > max - 4;
        };
        this.goPrev = () => this.track.scrollBy({ left: -this.step(), behavior: 'smooth' });
        this.goNext = () => this.track.scrollBy({ left: this.step(), behavior: 'smooth' });
        if (this.prev) this.prev.addEventListener('click', this.goPrev);
        if (this.next) this.next.addEventListener('click', this.goNext);
        this.track.addEventListener('scroll', this.sync, { passive: true });
        window.addEventListener('resize', this.sync);
        this.sync();
      }
      disconnectedCallback() {
        if (!this.track) return;
        if (this.prev) this.prev.removeEventListener('click', this.goPrev);
        if (this.next) this.next.removeEventListener('click', this.goNext);
        this.track.removeEventListener('scroll', this.sync);
        window.removeEventListener('resize', this.sync);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (function () {
    var list = document.querySelector('.cat-list[data-item-list]');
    if (!list) return;
    try {
      document.dispatchEvent(new CustomEvent('analytics:view_item_list', {
        detail: { item_list_name: list.dataset.itemList || 'collection', items_count: list.querySelectorAll('.tcard').length }
      }));
    } catch (e) { /* analytics best-effort */ }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function () {
    if (customElements.get('mk-product')) return;

    var inr = function (cents) { return '₹' + Math.round(cents / 100).toLocaleString('en-IN'); };
    var fill = function (s, k, v) { return String(s).replace('[' + k + ']', v); };
    var send = function (name, detail) {
      try { document.dispatchEvent(new CustomEvent('analytics:' + name, { detail: detail })); } catch (e) {}
    };

    class MkProduct extends HTMLElement {
      connectedCallback() {
        this._boot = this._boot || this.init.bind(this);
        /* tin.js and maison.js load deferred after the section bundle; wait for them */
        if ((window.MKTin && window.MKBag) || document.readyState === 'complete') this.init();
        else { document.addEventListener('DOMContentLoaded', this._boot, { once: true }); window.addEventListener('load', this._boot, { once: true }); }
      }

      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this._boot);
        window.removeEventListener('load', this._boot);
        if (this._ac) this._ac.abort();
        this._ac = null;
      }

      init() {
        if (this._ac) return;
        var node = this.querySelector('[data-pdp-json]');
        if (!node) return;
        try { this.d = JSON.parse(node.textContent); } catch (e) { return; }
        var self = this, d = this.d, on = { signal: (this._ac = new AbortController()).signal };
        var $ = function (s) { return self.querySelector(s); };
        var $$ = function (s) { return Array.prototype.slice.call(self.querySelectorAll(s)); };
        this.$ = $; this.$$ = $$;
        this.form = $('[data-pdp-form]');
        this.qty = 1;
        this.tinOn = false;

        this.values = (d.initial || []).slice();
        this.variant = this.find(this.values) || d.variants[0];
        if (this.variant && this.values.length !== this.variant.options.length) this.values = this.variant.options.slice();
        if (d.structured && d.roles.pack >= 0) this.tinOn = this.values[d.roles.pack] === d.tin && !!d.tin;
        this.labelStyle = d.label.style || 'maison';
        this.labelColour = d.label.colour || (window.MKTin && MKTin.DEFAULT[this.labelStyle]) || 'lilac';

        /* gallery */
        this.thumbs = $$('.g-thumb');
        this.slides = $$('.g-slide:not(.g-tin)');
        this.gTin = $('.g-tin');
        this.pTin = this.gTin ? this.gTin.querySelector('.mktin') : null;
        this.thumbs.forEach(function (t) { t.addEventListener('click', function () { self.show(+t.dataset.i); }, on); });

        /* tin designer */
        var sBox = $('[data-tin-styles]'), cBox = $('[data-tin-colours]');
        if (window.MKTin && sBox && cBox) {
          if (MKTin.style && !MKTin.style[this.labelStyle]) this.labelStyle = 'maison';
          if (MKTin.colour && !MKTin.colour[this.labelColour]) this.labelColour = MKTin.DEFAULT[this.labelStyle];
          MKTin.stylePicker(sBox, this.labelStyle, function (id) { self.labelStyle = id; self.labelColour = MKTin.DEFAULT[id]; MKTin.select(cBox, self.labelColour); self.sync(true); });
          MKTin.colourPicker(cBox, this.labelColour, function (id) { self.labelColour = id; self.sync(true); });
        }
        var tOn = $('[data-tin-on]'), tOff = $('[data-tin-off]'), tName = $('[data-tin-name]');
        if (tOn) tOn.addEventListener('click', function () { self.tinOn = true; self.sync(true, true); var n = $('[data-tin-name]'); if (n) n.focus({ preventScroll: true }); }, on);
        if (tOff) tOff.addEventListener('click', function () { self.tinOn = false; self.sync(false, true); }, on);
        if (tName) tName.addEventListener('input', function () { self.sync(); }, on);

        /* options */
        this.addEventListener('change', function (e) {
          var t = e.target;
          if (t.name === 'pdp-size') self.values[d.roles.size] = t.value;
          else if (t.name === 'pdp-plan') self.values[d.roles.plan] = t.value;
          else if (t.dataset && t.dataset.opt != null) self.values[+t.dataset.opt] = t.value;
          else return;
          self.sync(false, true);
        }, on);

        /* quantity */
        $$('.qty-step [data-q]').forEach(function (b) {
          b.addEventListener('click', function () {
            self.qty = Math.max(1, Math.min(20, self.qty + +b.dataset.q));
            var o = $('[data-qty-out]'); if (o) o.textContent = self.qty;
            var q = $('[data-pdp-qty]'); if (q) q.value = self.qty;
            self.syncPair();
          }, on);
        });

        /* "pair it with a 50 g tin": both lines in one /cart/add.js call */
        var pair = $('[data-pdp-pair]');
        if (pair) pair.addEventListener('submit', function (e) { self.addPair(e); }, on);

        if (this.form) this.form.addEventListener('submit', function (e) { self.submit(e); }, on);
        if (/[?&]tin\b/.test(location.search) && tOn && !$('[data-tin-row]').hidden) this.tinOn = true;

        this.sync();
        if (this.variant) send('view_item', this.meta({ variant_id: this.variant.id, price: this.variant.price / 100 }));
      }

      meta(extra) {
        return Object.assign({ item_id: this.d.product.id, item_name: this.d.product.title, currency: this.d.currency }, extra || {});
      }

      show(i) {
        this.slides.forEach(function (s, k) { s.classList.toggle('on', k === i); });
        this.thumbs.forEach(function (x) { x.classList.toggle('on', +x.dataset.i === i); });
        if (this.gTin) this.gTin.classList.remove('on');
      }

      find(vals) {
        var key = vals.join('\u0001');
        return this.d.variants.filter(function (v) { return v.options.join('\u0001') === key; })[0] || null;
      }

      /* the structured lookup: size, pack, plan in the product's option order */
      at(size, pack, plan) {
        var d = this.d, vals = this.values.slice();
        vals[d.roles.size] = size;
        if (d.roles.pack >= 0) vals[d.roles.pack] = pack;
        if (d.roles.plan >= 0) vals[d.roles.plan] = plan;
        return this.find(vals);
      }

      sync(bump, user) {
        var d = this.d, self = this, $ = this.$, $$ = this.$$, v;
        if (d.structured) {
          var R = d.roles, size = this.values[R.size], plan = R.plan >= 0 ? this.values[R.plan] : '';
          var g = parseFloat(size) || 0;
          var tinOk = !!(d.tin && this.at(size, d.tin, d.once || plan));
          if (!tinOk) this.tinOn = false;
          var pack = this.tinOn ? d.tin : d.pouch;
          if (R.pack >= 0) this.values[R.pack] = pack;
          /* no variant for this pack + plan (e.g. a tin on a plan): drop to the same pack bought once,
             then the pouch once, and show that choice so the UI matches what gets added */
          v = this.find(this.values) || this.at(size, pack, d.once) || this.at(size, d.pouch, d.once) || null;
          if (v) {
            this.values = v.options.slice();
            if (R.plan >= 0) plan = this.values[R.plan];
            if (R.pack >= 0 && this.values[R.pack] !== pack) { pack = this.values[R.pack]; this.tinOn = !!d.tin && pack === d.tin; }
          }

          /* size chips: the bought-once price in the current pack, saving per gram against the 50g pouch */
          var base = this.at('50g', d.pouch, d.once);
          $$('input[name="pdp-size"]').forEach(function (inp) {
            var lab = inp.closest('.sz'), x = inp.value, gx = parseFloat(x) || 0;
            var cv = (self.tinOn && self.at(x, d.tin, d.once)) || self.at(x, d.pouch, d.once);
            var sm = lab.querySelector('[data-sz-price]'); if (sm && cv) sm.textContent = inr(cv.price);
            lab.classList.toggle('is-sold', !!cv && !cv.available);
            inp.checked = x === size;
          });

          /* pouch or tin */
          var row = $('[data-tin-row]');
          if (row) {
            row.hidden = !tinOk || this.tinOn;
            $('[data-tin-none]').hidden = tinOk;
            $('[data-tin-custom]').hidden = !this.tinOn;
            var tv = this.at(size, d.tin, d.once), pvv = this.at(size, d.pouch, d.once), dl = $('[data-tin-delta]');
            if (dl) dl.textContent = tv && pvv && tv.price > pvv.price ? '+' + inr(tv.price - pvv.price) : '';
          }

          /* how often */
          var onceV = this.at(size, pack, d.once);
          $$('[data-plan-opt]').forEach(function (o) {
            var inp = o.querySelector('input'), pv = self.at(size, pack, inp.value), m = +o.dataset.months || 1;
            o.hidden = !pv;
            inp.checked = inp.value === plan;
            o.classList.toggle('on', inp.checked);
            if (!pv) return;
            var was = onceV ? onceV.price * m : 0, save = m > 1 && was > pv.price ? Math.round((1 - pv.price / was) * 100) : 0;
            o.querySelector('[data-po-price]').textContent = inr(pv.price);
            var s = o.querySelector('[data-po-was]'); if (s) s.textContent = save >= 1 ? inr(was) : '';
            var em = o.querySelector('[data-po-save]'); if (em) { em.hidden = save < 1; em.textContent = fill(d.i18n.save, 'percent', save); }
            var month = pv.price / m, cup = Math.max(100, Math.round(month * d.dose / (g || 100) / 100) * 100);
            o.querySelector('[data-po-small]').textContent = (m > 1 ? fill(d.i18n.aMonth, 'price', inr(month)) : size + ' ' + (self.tinOn ? d.i18n.tin : d.i18n.pouch)) + ' · ' + fill(d.i18n.aCup, 'price', inr(cup));
          });

          /* the tin in the gallery */
          if (this.gTin && this.pTin && window.MKTin) {
            var nmEl = $('[data-tin-name]'), nm = nmEl ? nmEl.value.trim() : '';
            if (this.tinOn) {
              this.slides.forEach(function (s) { s.classList.remove('on'); });
              this.thumbs.forEach(function (x) { x.classList.remove('on'); });
              this.gTin.classList.add('on');
              MKTin.paint(this.pTin, { name: nm, fallback: d.label.fallback, label: d.i18n.madeFor, kind: nm ? d.label.fallback : d.label.kind, style: this.labelStyle, colour: this.labelColour, size: g, bump: bump });
            } else if (this.gTin.classList.contains('on')) this.show(0);
          }
        } else {
          v = this.find(this.values);
          if (this.values.length > 1) {
            $$('input[data-opt]').forEach(function (inp) {
              var vals = self.values.slice(); vals[+inp.dataset.opt] = inp.value;
              var cv = self.find(vals), lab = inp.closest('.sz'), sm = lab.querySelector('[data-sz-price]');
              if (sm) sm.textContent = cv ? inr(cv.price) : '';
              lab.classList.toggle('is-sold', !cv || !cv.available);
            });
          }
        }

        /* the form */
        var add = $('[data-pdp-add]'), idIn = $('[data-pdp-id]');
        var changed = v && this.variant && v.id !== this.variant.id;
        this.variant = v;
        if (idIn && v) idIn.value = v.id;
        if (add) {
          var ok = !!(v && v.available);
          add.disabled = !ok;
          add.textContent = ok ? d.i18n.add : d.i18n.soldOut;
        }
        var wl = $('[data-pdp-waitlist]'); if (wl) wl.hidden = !!(v && v.available);
        var err = $('[data-add-error]'); if (err && user) err.hidden = true;
        this.syncValue();
        this.syncPair();
        if (user && changed) {
          try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u); } catch (e) {}
          send('variant_selected', this.meta({ variant_id: v.id, price: v.price / 100 }));
        }
      }

      /* per-gram saving of 100 g over 50 g in the selected pack and plan (mirrors snippets/size-saving) */
      syncValue() {
        var el = this.$('[data-pdp-value]'), d = this.d, si = d.sizeIndex, cur = this.variant;
        if (!el) return;
        var pct = 0;
        if (cur && si >= 0) {
          var num = function (x) { var t = String(x).toLowerCase().split(' ')[0].replace(/gm|g/g, ''); return { g: parseFloat(t) || 0, sfx: String(x).toLowerCase().replace(t, '').trim() }; };
          var rows = d.variants.filter(function (v) {
            return v.options.every(function (o, k) { return k === si || o === cur.options[k]; });
          }).map(function (v) { var n = num(v.options[si]); return { g: n.g, sfx: n.sfx, v: v }; });
          var a = null, b = null;
          rows.some(function (r) {
            if (r.g !== 100 || !r.v.available) return false;
            var m = rows.filter(function (q) { return q.g === 50 && q.sfx === r.sfx; })[0];
            if (m) { a = r.v; b = m.v; return true; }
            return false;
          });
          if (!a) {
            a = (rows.filter(function (r) { return r.g === 100 && r.v.available; })[0] || {}).v;
            b = (rows.filter(function (r) { return r.g === 50; })[0] || {}).v;
          }
          if (a && b && b.price > 0) pct = Math.floor(100 - a.price * 50 / b.price);
        }
        el.hidden = pct < 1;
        if (pct >= 1) el.textContent = d.i18n.value ? fill(d.i18n.value, 'percent', pct) : d.i18n.valuePlain;
      }

      /* the cheapest suggested 50 g tin that takes this selection to free shipping; hidden if none does */
      syncPair() {
        var box = this.$('[data-pdp-pair]'); if (!box) return;
        var v = this.variant, th = +box.dataset.threshold || 0, cur = v && v.available ? v.price * this.qty : 0, pick = null;
        var items = Array.prototype.slice.call(box.querySelectorAll('[data-pp-item]'));
        if (cur > 0 && cur < th) items.some(function (it) { if (cur + +it.dataset.price >= th) { pick = it; return true; } return false; });
        items.forEach(function (it) { it.hidden = it !== pick; });
        box.hidden = !pick;
        this.pairPick = pick;
        if (!pick) return;
        box.querySelector('[data-pp-cur]').value = v.id;
        box.querySelector('[data-pp-cur-qty]').value = this.qty;
        box.querySelector('[data-pp-sug]').value = pick.dataset.id;
        box.querySelector('[data-pp-total]').textContent = fill(this.d.i18n.pairTotal, 'price', inr(cur + +pick.dataset.price));
      }

      addPair(e) {
        var self = this, v = this.variant, pick = this.pairPick;
        if (!window.MKBag || !document.querySelector('cart-drawer')) return;  /* posts natively */
        e.preventDefault();
        if (!v || !v.available || !pick) return;
        var box = this.$('[data-pdp-pair]'), btn = box.querySelector('[data-pp-add]'), err = box.querySelector('[data-pp-error]');
        var first = { id: v.id, quantity: this.qty }, props = this.properties();
        if (props) first.properties = props;
        btn.disabled = true; btn.setAttribute('aria-busy', 'true'); if (err) err.hidden = true;
        MKBag.add([first, { id: +pick.dataset.id, quantity: 1 }], { source: 'pdp_pair', analytics: { pair_with: this.d.product.id } }).catch(function (x) {
          if (err) { err.textContent = (x && x.message) || self.d.i18n.addError; err.hidden = false; }
        }).then(function () { btn.disabled = false; btn.removeAttribute('aria-busy'); });
      }

      properties() {
        if (!this.tinOn) return null;
        var n = this.$('[data-tin-name]'), name = n ? n.value.trim() : '', p = {};
        if (name) p['Name on tin'] = name;
        p._label_style = this.labelStyle;
        p._label_colour = this.labelColour;
        return p;
      }

      submit(e) {
        var self = this, v = this.variant;
        if (!window.MKBag || !document.querySelector('cart-drawer')) {
          /* no drawer: post natively, carrying the tin properties */
          var p = this.properties();
          if (p) Object.keys(p).forEach(function (k) {
            var i = document.createElement('input'); i.type = 'hidden'; i.name = 'properties[' + k + ']'; i.value = p[k]; self.form.appendChild(i);
          });
          return;
        }
        e.preventDefault();
        if (!v || !v.available) return;
        var btn = this.$('[data-pdp-add]'), err = this.$('[data-add-error]'), d = this.d, props = this.properties();
        var item = { id: v.id, quantity: this.qty };
        if (props) item.properties = props;
        btn.disabled = true; btn.setAttribute('aria-busy', 'true');
        var extra = { item_name: d.product.title, item_variant: v.options.join(' / ') };
        if (d.structured) {
          extra.size = v.options[d.roles.size];
          if (d.roles.pack >= 0) extra.pack = v.options[d.roles.pack];
          if (d.roles.plan >= 0) extra.plan = v.options[d.roles.plan];
          extra.named_tin = !!(props && props['Name on tin']);
        }
        MKBag.add(item, { source: 'pdp', analytics: extra }).catch(function (x) {
          if (err) { err.textContent = (x && x.message) || d.i18n.addError; err.hidden = false; }
        }).then(function () { btn.disabled = !(self.variant && self.variant.available); btn.removeAttribute('aria-busy'); });
      }
    }

    customElements.define('mk-product', MkProduct);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  (function () {
    var el = document.querySelector('.mk-search-hero[data-search-term]');
    if (!el) return;
    try {
      document.dispatchEvent(new CustomEvent('analytics:search', {
        detail: { search_term: el.dataset.searchTerm, results_count: Number(el.dataset.resultsCount || 0), source: 'search_page' }
      }));
    } catch (e) { /* analytics best-effort */ }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pages-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function show(scope) {
      (scope || document).querySelectorAll('[data-wa-show][data-wa-a]').forEach(function (a) {
        try {
          var n = atob(a.dataset.waA) + atob(a.dataset.waB);
          a.textContent = n.length === 12 ? '+' + n.slice(0, 2) + ' ' + n.slice(2, 7) + ' ' + n.slice(7) : '+' + n;
        } catch (e) {}
      });
    }
    show(document);
    document.addEventListener('shopify:section:load', function (e) { show(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["starter-pairs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('mk-pairs')) return;
    class MkPairs extends HTMLElement {
      connectedCallback() {
        this._submit = this._submit.bind(this);
        this.addEventListener('submit', this._submit);
      }
      disconnectedCallback() {
        this.removeEventListener('submit', this._submit);
      }
      _submit(e) {
        var form = e.target.closest('[data-sp-form]');
        if (!form || !window.MKBag || !document.querySelector('cart-drawer')) return;
        e.preventDefault();
        var fd = new FormData(form), items = [];
        for (var i = 0; fd.get('items[' + i + '][id]'); i++) items.push({ id: fd.get('items[' + i + '][id]'), quantity: fd.get('items[' + i + '][quantity]') || 1 });
        var btn = form.querySelector('[type="submit"]'), err = form.querySelector('[data-add-error]');
        btn.disabled = true; btn.setAttribute('aria-busy', 'true'); if (err) err.hidden = true;
        window.MKBag.add(items, { source: 'starter_pair' }).catch(function (x) {
          if (err) { err.textContent = x && x.message ? x.message : ''; err.hidden = !err.textContent; }
        }).then(function () { btn.disabled = false; btn.removeAttribute('aria-busy'); });
      }
    }
    customElements.define('mk-pairs', MkPairs);
  })();

  } catch(e) { console.error(e); }
})();
})();
